import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell.js";
import {
  RedirectIfSetupIncomplete,
  RequireAuth,
  RequireSetupComplete,
} from "./components/guards.js";
import { AcceptInvitationPage } from "./pages/AcceptInvitation.js";
import { DashboardPage } from "./pages/Dashboard.js";
import { ForgotPasswordPage } from "./pages/ForgotPassword.js";
import { LoginPage } from "./pages/Login.js";
import { NotFoundPage } from "./pages/NotFound.js";
import { OfflinePage } from "./pages/OfflinePage.js";
import { ResetPasswordPage } from "./pages/ResetPassword.js";
import { SetupPage } from "./pages/Setup.js";
import { customersRoutes } from "./features/customers/routes.js";
import { requestsRoutes } from "./features/requests/routes.js";
import { offersRoutes } from "./features/offers/routes.js";
import { projectsRoutes } from "./features/projects/routes.js";
import { invoicesRoutes } from "./features/invoices/routes.js";
import { settingsRoutes } from "./features/settings/routes.js";
import { catalogRoutes } from "./features/catalog/routes.js";
import { dashboardRoutes } from "./features/dashboard/routes.js";
import { employeesRoutes } from "./features/employees/routes.js";

const featureRoutes = [
  ...dashboardRoutes,
  ...employeesRoutes,
  ...customersRoutes,
  ...requestsRoutes,
  ...offersRoutes,
  ...projectsRoutes,
  ...invoicesRoutes,
  ...catalogRoutes,
  ...settingsRoutes,
];

/**
 * Route map. Domain list/detail pages are plugged in under the shell route
 * by the screen agents; unknown paths inside the shell render NotFound with
 * navigation intact, outside render the bare page.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/invite/:token" element={<AcceptInvitationPage />} />
        <Route
          path="/setup"
          element={
            <RedirectIfSetupIncomplete>
              <SetupPage />
            </RedirectIfSetupIncomplete>
          }
        />
        <Route path="/offline" element={<OfflinePage />} />

        {/* Authenticated shell */}
        <Route
          element={
            <RequireAuth>
              <RequireSetupComplete>
                <AppShell />
              </RequireSetupComplete>
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          {featureRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={r.element} />
          ))}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
